import {Validator} from 'vee-validate'
import {required} from 'vee-validate/dist/rules.esm'

export default {
  name: 'Password',
  inject: {
    $validator: '$validator'
  },
  props: {
    value: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      passwordValue: ''
    }
  },
  watch: {
    value (val) {
      this.passwordValue = val
    }
  },
  created(){
    Validator.extend('required', {
      validate: required,
      getMessage: (field, params, data) => {
        return 'Nif is required'
      }
    })

  },
  methods: {
    updatePasswordData (event) {
      this.passwordValue = event.target.value
      this.$emit('input', this.passwordValue)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/component/inputs/password/password.js